<template>
    <div class="active tab-pane params" id="specifications" role="tabpanel" aria-expanded="false">
        <article>
            <h2 class="param-title">
                <!--مشخصات فنی-->
                <span>{{productInfo.SchemaCode}}</span>
            </h2>
            <section v-for="ProductPropertyGroup in productInfo.ProductPropertyGroups">
                <h3 class="params-title">{{ProductPropertyGroup.GroupTitle}}</h3>
                <ul class="params-list">
                    <li v-for="ProductPropertyValue in ProductPropertyGroup.ProductPropertyValue">
                        <div class="params-list-key">
                            <span class="block">{{ProductPropertyValue.PropertyTitle}}</span>
                        </div>
                        <div class="params-list-value">
                            <span class="flex-f">
                                {{ProductPropertyValue.PropertyValue == null || ProductPropertyValue.PropertyValue == '' ? '----' : ProductPropertyValue.PropertyValue}}
                            </span>
                        </div>
                    </li>
                </ul>
            </section>
        </article>
    </div>
</template>

<script>
    export default {
        props: {
            productInfo: {
                type: Object,
            },
        },
    }
</script>

<style scoped>
    .params section {
        float: none;
    }
    .params .params-list li {
      
        background-color: #f9f9f9;
       /* margin-right: 20px;*/
    }

    .params section {
        float: none;
        overflow: hidden;
    }
    .params h3.params-title {
        margin: 0 0 10px;
        color: #3483cd;
        font-size: 17px;
        font-weight: 400;
        padding: 15px 0 15px 15px;
        display: block;
       
        /*   display: block;
        background-color: #e6dede;
        padding: 13px;*/
    }
    .params .params-list li .params-list-key {
        line-height: 23px;
        padding: 2px 5px;
        text-align: right;
        text-shadow: 0 1px 1px #ffffff;
        vertical-align: middle;
        background: #f0f1f2;
        height: auto;
        padding: 9px 21px;
        margin-left: 19px;
        width: 25%;
    }
    .params .params-title::before {
        right: 2px;
        bottom: 20px;
    }
    .params .params-title {
        top: 15px;
    }
    @media only screen and (min-width: 0px) and (max-width: 640px) {
        .params .params-list li {
    
            background-color: #f9f9f9;
            margin-right: 10px;
        }
    }
</style>